@use "styles/abstracts/variables" as v;

.overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
  backdrop-filter: blur(2px);
  background-color: #29292933;
  z-index: v.$z-index-backdrop;
  overflow-y: auto;

  @media (max-width: 768px) {
    padding: max(12px, env(safe-area-inset-top)) 12px max(12px, env(safe-area-inset-bottom));
  }

  @media (max-width: 480px) {
    padding: max(8px, env(safe-area-inset-top)) 8px max(8px, env(safe-area-inset-bottom));
  }
}

.overlayCentered {
  align-items: center;
  justify-content: center;
}

.modal {
  position: relative;
  margin: auto;
  padding: 24px;
  background-color: v.$palette-white;
  border-radius: 16px;
  box-shadow: v.$shadow4;
  max-width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 16px;
    border-radius: 12px;
  }
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;

  @media (max-width: 480px) {
    top: 12px;
    right: 12px;
  }
}
